import ModalService from '@/modules/core/ui/services/ModalService';
import { MeetingType } from '@/modules/meeting/constants/MeetingType';
import { MeetingStatus } from '@/modules/meeting/constants/MeetingStatus';
import { CalendarMeetingLinkFreeConsultLink } from '@/modules/calendarmeetinglink/constants/CalendarMeetingLinkFreeConsultLink';
import { MeetingSchedulerModalId } from '@/modules/meeting/constants/MeetingSchedulerModalId';
import { Meeting } from '@/modules/meeting/models/Meeting';
import { CalendarMeetingLink } from '@/modules/calendarmeetinglink/models/CalendarMeetingLink';
import { MeetingSchedulerModalComponentFactory } from '@/modules/meeting/services/MeetingSchedulerModalComponentFactory';
import { BaseUIService } from '@/modules/core/ui/services/BaseUIService';
import { LocaleType } from '@/modules/user/constants/LocaleType';

// Type definition for Buefy Vue 3
interface BModalComponent {
  close: () => void;
  $refs: Record<string, unknown>;
  $el: unknown;
  $parent?: unknown;
  [key: string]: unknown;
}

export class MeetingFreeConsultModalService extends BaseUIService {
  async show(
    parent: Vue.Component,
    jurisdictionId: number,
    props: Record<string, unknown> = {},
    modalOptions: Record<string, unknown> = {}
  ): Promise<BModalComponent> {
    return ModalService.show({
      parent,
      modalId: MeetingSchedulerModalId.MEETING_SCHEDULER_MODAL.toString(),
      component: await MeetingSchedulerModalComponentFactory.build(MeetingType.FREE_CONSULT.key),
      props: {
        ...props,
        meeting: Meeting.mapModel({
          type: MeetingType.FREE_CONSULT.key,
          status: MeetingStatus.AVAILABLE.key,
          calendarMeetingLink: CalendarMeetingLink.mapModel({
            englishUrl: CalendarMeetingLinkFreeConsultLink.getLocalizedLink(
              jurisdictionId,
              LocaleType.ENGLISH
            )?.toString(),
            frenchUrl: CalendarMeetingLinkFreeConsultLink.getLocalizedLink(
              jurisdictionId,
              LocaleType.FRENCH
            )?.toString()
          })
        }),
        jurisdictionId
      },
      fullScreen: true,
      ...modalOptions
    });
  }
}

export default new MeetingFreeConsultModalService();
